/* =============================================================
   F&NT · Tarjeta de producto (snippets/fnt-product-card.liquid)
   - Una opción: agrega directo.
   - Varias opciones: computadora → panel sobre la foto;
                      celular (≤749px) → hoja desde abajo.
   - Al agregar se abre el carrito del tema (igual que en la ficha).
   - Etiqueta "EN CARRITO · n" en cada tarjeta, sincronizada con el carrito.
   Funciona con tarjetas que llegan después (recomendaciones, pestañas).
   ============================================================= */
(function () {
  if (window.FntCard) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MOBILE = window.matchMedia('(max-width: 749px)');

  // Colores de sabor (mismos que la ficha)
  var FLAVOR_COLORS = {
    'vainilla': '#F1E3B8', 'chocolate': '#6B3F2A', 'fresa': '#E56A82', 'nuez': '#B98A4F',
    'uva': '#7B3F8C', 'blueberry': '#4F5BB5', 'mango-durazno': '#F4A340', 'naranja': '#F28C28',
    'limón': '#D7E04A', 'limon': '#D7E04A', 'piña': '#F2C94C', 'pina': '#F2C94C', 'manzana': '#8CC63F',
    'té verde': '#8DB255', 'te verde': '#8DB255', 'arándano': '#A3264A', 'arandano': '#A3264A',
    'sin sabor': '#BFE3F5', 'natural': '#BFE3F5'
  };
  var SIZE_NAMES = ['gramaje', 'presentación', 'presentacion', 'tamaño', 'tamano'];

  // ---------- Utilidades ----------
  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0
      ? n.toLocaleString('es-MX')
      : n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function perPortion(cents, porc) {
    var v = cents / porc / 100;
    return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function singular(unit) {
    return unit === 'servicios' ? 'servicio' : (unit === 'porciones' ? 'porción' : unit);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function norm(s) {
    return String(s || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function kind(name) {
    var n = norm(name);
    if (SIZE_NAMES.indexOf(n) > -1) return 'size';
    if (n.indexOf('sabor') > -1) return 'flavor';
    return 'other';
  }

  // ---------- Suscripción (planes de Shopify Subscriptions) ----------
  function planLabel(name) {
    var t = String(name || '').split(',')[0].trim().replace(/^entregar\s+/i, '');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function hasPlans(d) {
    return !!(d && d.plans && d.plans.length);
  }

  function planState(holder, d) {
    if (!hasPlans(d)) return null;
    if (!holder._plan) holder._plan = { sub: true, id: d.plans[0].id };
    return holder._plan;
  }

  // Variante con el precio que se va a cobrar (suscripción: precio del plan, tachado el normal)
  function priced(v, st) {
    if (!st || !st.sub || !v.sp || v.sp >= v.price) return v;
    var out = {};
    for (var k in v) out[k] = v[k];
    out.price = v.sp;
    out.compare = v.price;
    return out;
  }

  function renderPlan(d, v, st) {
    if (!st) return '';
    var pct = v.sp && v.price ? Math.round((1 - v.sp / v.price) * 100) : 0;
    var opts = d.plans.map(function (p) {
      return '<option value="' + p.id + '"' + (p.id === st.id ? ' selected' : '') + '>' + esc(planLabel(p.name)) + '</option>';
    }).join('');
    return '<div class="fnt-opt__group fnt-buy">' +
      '<p class="fnt-opt__label">Forma de compra</p>' +
      '<div class="fnt-buy__tiles">' +
        '<button type="button" class="fnt-buy__tile' + (st.sub ? ' is-on' : '') + '" data-fnt-buy="sub" aria-pressed="' + st.sub + '">' +
          '<b>Suscríbete' + (pct ? ' −' + pct + '%' : '') + '</b><span>' + (v.sp ? money(v.sp) : '') + '</span></button>' +
        '<button type="button" class="fnt-buy__tile' + (!st.sub ? ' is-on' : '') + '" data-fnt-buy="once" aria-pressed="' + !st.sub + '">' +
          '<b>Compra única</b><span>' + money(v.price) + '</span></button>' +
      '</div>' +
      (st.sub
        ? '<label class="fnt-buy__freq"><span class="visually-hidden">Frecuencia</span><select data-fnt-freq>' + opts + '</select></label>'
        : '') +
    '</div>';
  }

  function addLabel(st, short) {
    if (st && st.sub) return short ? 'Suscribirme' : 'Agregar suscripción';
    return short ? 'Agregar' : 'Agregar al carrito';
  }

  function data(card) {
    if (card._fnt === undefined) {
      var el = card.querySelector('[data-fnt-pc-data]');
      try { card._fnt = el ? JSON.parse(el.textContent) : null; } catch (e) { card._fnt = null; }
    }
    return card._fnt;
  }

  function sizeIndex(d) {
    for (var i = 0; i < d.options.length; i++) if (kind(d.options[i]) === 'size') return i;
    return -1;
  }

  function findVariant(d, sel) {
    return d.variants.find(function (v) {
      return v.o.every(function (x, i) { return x === sel[i]; });
    });
  }

  function valueAvailable(d, sel, idx, value) {
    return d.variants.some(function (v) {
      if (!v.a || v.o[idx] !== value) return false;
      return v.o.every(function (x, i) { return i === idx || x === sel[i]; });
    });
  }

  function valuesOf(d, idx) {
    var out = [];
    d.variants.forEach(function (v) { if (out.indexOf(v.o[idx]) === -1) out.push(v.o[idx]); });
    return out;
  }

  // ---------- Estado original de la tarjeta ----------
  function snapshot(card) {
    if (card._orig) return;
    var img = card.querySelector('.fnt-pc__img');
    var btn = card.querySelector('[data-fnt-pc-btn]');
    card._orig = {
      src: img ? img.getAttribute('src') : null,
      srcset: img ? img.getAttribute('srcset') : null,
      price: card.querySelector('[data-fnt-pc-price]').outerHTML,
      was: card.querySelector('[data-fnt-pc-was]').outerHTML,
      l1: card.querySelector('[data-fnt-pc-l1]').textContent,
      l2: card.querySelector('[data-fnt-pc-l2]').textContent,
      btn: btn.innerHTML,
      save: card.querySelector('[data-fnt-pc-save]') ? card.querySelector('[data-fnt-pc-save]').outerHTML : null
    };
  }

  function restore(card) {
    var o = card._orig;
    if (!o) return;
    var img = card.querySelector('.fnt-pc__img');
    if (img && o.src) {
      img.setAttribute('src', o.src);
      if (o.srcset) img.setAttribute('srcset', o.srcset);
    }
    card.querySelector('[data-fnt-pc-price]').outerHTML = o.price;
    card.querySelector('[data-fnt-pc-was]').outerHTML = o.was;
    card.querySelector('[data-fnt-pc-l1]').textContent = o.l1;
    card.querySelector('[data-fnt-pc-l2]').textContent = o.l2;
    setSaveTag(card, o.save);
    var btn = card.querySelector('[data-fnt-pc-btn]');
    btn.innerHTML = o.btn;
    btn.dataset.mode = 'choose';
    btn.disabled = false;
  }

  function setSaveTag(card, html) {
    var tags = card.querySelector('[data-fnt-pc-tags]');
    var cur = tags.querySelector('[data-fnt-pc-save]');
    var best = tags.querySelector('.fnt-pc__tag--best');
    if (cur) cur.remove();
    if (html) {
      tags.insertAdjacentHTML('afterbegin', html);
      if (best) best.hidden = true;
    } else if (best) {
      best.hidden = false;
    }
  }

  // ---------- Tarjeta al elegir ----------
  function paintCard(card, d, v) {
    var img = card.querySelector('.fnt-pc__img');
    if (img && v.img && img.getAttribute('src') !== v.img) {
      img.removeAttribute('srcset');
      img.setAttribute('src', v.img);
    }
    var sale = v.compare > v.price;
    var price = card.querySelector('[data-fnt-pc-price]');
    price.textContent = money(v.price);
    price.classList.toggle('is-sale', sale);
    var was = card.querySelector('[data-fnt-pc-was]');
    was.hidden = !sale;
    was.textContent = sale ? money(v.compare) : '';
    setSaveTag(card, sale
      ? '<span class="fnt-pc__tag fnt-pc__tag--save" data-fnt-pc-save>Ahorra ' + Math.round((1 - v.price / v.compare) * 100) + '%</span>'
      : null);

    var si = sizeIndex(d);
    var l1 = card.querySelector('[data-fnt-pc-l1]');
    var l2 = card.querySelector('[data-fnt-pc-l2]');
    if (d.combo) {
      l1.textContent = card._orig.l1;
      l2.textContent = sale ? 'Ahorras ' + money(v.compare - v.price) : '';
    } else {
      var parts = [];
      if (si > -1) parts.push(v.o[si]);
      if (v.porc) parts.push(v.porc + ' ' + d.unit);
      l1.textContent = parts.length ? parts.join(' · ') : card._orig.l1;
      l2.textContent = v.porc ? perPortion(v.price, v.porc) + ' por ' + singular(d.unit) : '';
    }
    var btn = card.querySelector('[data-fnt-pc-btn]');
    btn.disabled = !v.a;
    btn.dataset.variant = v.id;
    card.querySelectorAll('.fnt-pc__img-link, .fnt-pc__title').forEach(function (a) { a.href = v.url; });
  }

  // ---------- Opciones (panel y hoja comparten el mismo HTML) ----------
  function groupsFor(d) {
    var groups = [];
    if (d.combo && d.combo.length) {
      d.combo.forEach(function (it) {
        if (it.regalo) return;
        var idx = it.opcion ? d.options.indexOf(it.opcion) : -1;
        if (idx > -1) groups.push({ idx: idx, title: it.nombre });
        else groups.push({ fixed: it.sabor_fijo || '', title: it.nombre });
      });
      d.options.forEach(function (n, i) {
        if (!groups.some(function (g) { return g.idx === i; })) groups.push({ idx: i, title: null });
      });
    } else {
      d.options.forEach(function (n, i) { groups.push({ idx: i, title: null }); });
    }
    return groups;
  }

  function renderOptions(d, sel) {
    var combo = !!(d.combo && d.combo.length);
    var html = '';
    groupsFor(d).forEach(function (g) {
      var head = g.title ? '<p class="fnt-opt__prod">' + esc(g.title) + '</p>' : '';
      if (g.idx === undefined) {
        html += '<div class="fnt-opt__group is-fixed">' + head +
          '<p class="fnt-opt__label">Sabor: <b>' + esc(g.fixed) + '</b></p></div>';
        return;
      }
      var name = d.options[g.idx];
      var k = kind(name);
      var values = valuesOf(d, g.idx);
      var label = k === 'size' ? 'Presentación' : (k === 'flavor' ? 'Sabor' : name);
      if (values.length <= 1) {
        if (!combo || !g.title) return;
        html += '<div class="fnt-opt__group is-fixed">' + head +
          '<p class="fnt-opt__label">' + esc(label) + ': <b>' + esc(values[0]) + '</b></p></div>';
        return;
      }
      html += '<div class="fnt-opt__group">' + head +
        '<p class="fnt-opt__label">' + esc(label) + ': <b>' + esc(sel[g.idx]) + '</b></p>' +
        '<div class="fnt-opt__list fnt-opt__list--' + k + '">';
      values.forEach(function (val) {
        var on = sel[g.idx] === val;
        var off = !valueAvailable(d, sel, g.idx, val);
        var dot = k === 'flavor'
          ? '<i class="fnt-opt__dot" style="background:' + (FLAVOR_COLORS[norm(val)] || '#777') + '"></i>'
          : '';
        html += '<button type="button" class="fnt-opt__btn fnt-opt__btn--' + k +
          (on ? ' is-on' : '') + (off ? ' is-off' : '') +
          '" data-fnt-idx="' + g.idx + '" data-fnt-val="' + esc(val) + '" aria-pressed="' + on + '">' +
          dot + '<span>' + esc(val) + '</span></button>';
      });
      html += '</div></div>';
    });
    return '<div class="fnt-opt' + (combo ? ' is-combo' : '') + '">' + html + '</div>';
  }

  function choose(d, sel, idx, value) {
    var next = sel.slice();
    next[idx] = value;
    var v = findVariant(d, next);
    if (!v || !v.a) {
      var alt = d.variants.find(function (x) { return x.a && x.o[idx] === value; });
      if (alt) next = alt.o.slice();
    }
    return next;
  }

  function initialSelection(card, d) {
    var start = d.variants.find(function (v) { return v.id === d.start; }) || d.variants[0];
    var sel = start.o.slice();
    // Filtro activo en la colección: abre en esa opción si existe
    var holder = card.closest('[data-fnt-pref]');
    if (holder && holder.dataset.fntPref) {
      try {
        var pref = JSON.parse(holder.dataset.fntPref);
        d.options.forEach(function (name, i) {
          var want = pref[norm(name)];
          if (!want) return;
          var match = valuesOf(d, i).find(function (val) { return norm(val) === want; });
          if (match) sel = choose(d, sel, i, match);
        });
      } catch (e) {}
    }
    return sel;
  }

  // ---------- Panel (computadora) ----------
  var openCard = null;

  function openPanel(card) {
    var d = data(card);
    if (!d) return;
    if (openCard && openCard !== card) closePanel(openCard);
    snapshot(card);
    card._sel = card._sel || initialSelection(card, d);
    card._plan = null;
    planState(card, d);
    card.querySelector('[data-fnt-pc-panel]').hidden = false;
    card.classList.add('is-open');
    var btn = card.querySelector('[data-fnt-pc-btn]');
    btn.dataset.mode = 'add';
    openCard = card;
    drawPanel(card);
  }

  function drawPanel(card) {
    var d = data(card);
    var v = findVariant(d, card._sel) || d.variants[0];
    var st = planState(card, d);
    card.querySelector('[data-fnt-pc-opts]').innerHTML = renderOptions(d, card._sel) + renderPlan(d, v, st);
    paintCard(card, d, priced(v, st));
    var btn = card.querySelector('[data-fnt-pc-btn]');
    if (btn.dataset.mode === 'add' && !btn.getAttribute('aria-busy') && !btn.classList.contains('is-added')) {
      btn.innerHTML = v.a
        ? '<span class="fnt-pc__long">' + addLabel(st) + '</span><span class="fnt-pc__short">' + addLabel(st, true) + '</span>'
        : '<span>Agotado</span>';
    }
  }

  function closePanel(card) {
    if (!card) return;
    var panel = card.querySelector('[data-fnt-pc-panel]');
    if (panel) panel.hidden = true;
    card.classList.remove('is-open');
    card._sel = null;
    card._plan = null;
    restore(card);
    if (openCard === card) openCard = null;
  }

  // ---------- Hoja (celular) ----------
  var sheet = null;
  var sheetCard = null;

  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'fnt-sheet';
    sheet.setAttribute('aria-label', 'Elegir opciones');
    sheet.innerHTML =
      '<div class="fnt-sheet__panel">' +
        '<div class="fnt-sheet__grip" data-fnt-grip><span></span></div>' +
        '<div class="fnt-sheet__head" data-fnt-grip>' +
          '<div class="fnt-sheet__thumb"><img alt="" width="120" height="120" data-fnt-sh-img></div>' +
          '<div class="fnt-sheet__info">' +
            '<p class="fnt-sheet__title" data-fnt-sh-title></p>' +
            '<p class="fnt-sheet__price"><b data-fnt-sh-price></b> <s data-fnt-sh-was></s></p>' +
            '<p class="fnt-sheet__meta" data-fnt-sh-meta></p>' +
          '</div>' +
          '<button type="button" class="fnt-sheet__close" data-fnt-sh-close aria-label="Cerrar">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="fnt-sheet__body" data-fnt-sh-opts></div>' +
        '<div class="fnt-sheet__foot"><button type="button" class="fnt-sheet__add" data-fnt-sh-add>Agregar al carrito</button>' +
          '<p class="fnt-sheet__note" data-fnt-sh-note hidden>Se cobra en cada entrega. Pausa o cancela desde tu cuenta.</p></div>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-fnt-sh-close]')) { closeSheet(); return; }
      var opt = e.target.closest('[data-fnt-idx]');
      if (opt && sheetCard) {
        var d = data(sheetCard);
        sheetCard._sel = choose(d, sheetCard._sel, Number(opt.dataset.fntIdx), opt.dataset.fntVal);
        drawSheet();
        return;
      }
      var buy = e.target.closest('[data-fnt-buy]');
      if (buy && sheetCard && sheetCard._plan) {
        sheetCard._plan.sub = buy.dataset.fntBuy === 'sub';
        drawSheet();
        return;
      }
      var add = e.target.closest('[data-fnt-sh-add]');
      if (add && sheetCard) {
        var dd = data(sheetCard);
        var v = findVariant(dd, sheetCard._sel);
        if (!v || !v.a) return;
        var card = sheetCard;
        var plan = sheetCard._plan && sheetCard._plan.sub && v.sp ? sheetCard._plan.id : null;
        addToCart(v.id, add, function () { return closeSheet(true); }, plan).then(function (ok) {
          if (ok) flashAdded(card);
        });
      }
    });
    sheet.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-fnt-freq]');
      if (sel && sheetCard && sheetCard._plan) sheetCard._plan.id = Number(sel.value);
    });
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); });

    // Deslizar hacia abajo para cerrar
    var startY = null;
    var panel = sheet.querySelector('.fnt-sheet__panel');
    sheet.addEventListener('touchstart', function (e) {
      if (!e.target.closest('[data-fnt-grip]')) return;
      startY = e.touches[0].clientY;
      panel.style.transition = 'none';
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    sheet.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      startY = null;
      panel.style.transition = '';
      panel.style.transform = '';
      if (dy > 80) closeSheet();
    });
    return sheet;
  }

  function openSheet(card) {
    var d = data(card);
    if (!d) return;
    buildSheet();
    snapshot(card);
    sheetCard = card;
    card._sel = initialSelection(card, d);
    card._plan = null;
    planState(card, d);
    sheet.querySelector('[data-fnt-sh-title]').textContent = d.title;
    drawSheet();
    document.documentElement.classList.add('fnt-sheet-lock');
    sheet.showModal();
    requestAnimationFrame(function () { sheet.classList.add('is-in'); });
  }

  function drawSheet() {
    var d = data(sheetCard);
    var base = findVariant(d, sheetCard._sel) || d.variants[0];
    var st = planState(sheetCard, d);
    var v = priced(base, st);
    var img = sheet.querySelector('[data-fnt-sh-img]');
    var src = v.img || d.image;
    if (src && img.getAttribute('src') !== src) img.src = src;
    img.hidden = !src;
    sheet.querySelector('[data-fnt-sh-price]').textContent = money(v.price);
    var was = sheet.querySelector('[data-fnt-sh-was]');
    was.textContent = v.compare > v.price ? money(v.compare) : '';
    var meta = [];
    var si = sizeIndex(d);
    if (!d.combo) {
      if (si > -1) meta.push(v.o[si]);
      if (v.porc) meta.push(v.porc + ' ' + d.unit);
    } else if (v.compare > v.price) {
      meta.push('Ahorras ' + money(v.compare - v.price));
    }
    sheet.querySelector('[data-fnt-sh-meta]').textContent = meta.join(' · ');
    sheet.querySelector('[data-fnt-sh-opts]').innerHTML = renderOptions(d, sheetCard._sel) + renderPlan(d, base, st);
    var add = sheet.querySelector('[data-fnt-sh-add]');
    add.disabled = !v.a;
    add.textContent = v.a ? addLabel(st) : 'Agotado';
    sheet.querySelector('[data-fnt-sh-note]').hidden = !(st && st.sub);
  }

  function closeSheet(keep) {
    return new Promise(function (resolve) {
      if (!sheet || !sheet.open) { resolve(); return; }
      sheet.classList.remove('is-in');
      setTimeout(function () {
        sheet.close();
        document.documentElement.classList.remove('fnt-sheet-lock');
        if (sheetCard) {
          sheetCard._sel = null;
          sheetCard._plan = null;
          restore(sheetCard);
        }
        sheetCard = null;
        requestAnimationFrame(function () { resolve(); });
      }, 220);
    });
  }

  // ---------- Carrito ----------
  function addToCart(variantId, button, beforeNotify, sellingPlan) {
    var original = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Agregando…';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [sellingPlan
          ? { id: Number(variantId), quantity: 1, selling_plan: Number(sellingPlan) }
          : { id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'cart/add');
          return json;
        });
      })
      .then(function (json) {
        return Promise.resolve(beforeNotify ? beforeNotify() : null).then(function () {
          notifyCart(variantId, json.sections);
        });
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        // Si el panel se cerró, la tarjeta ya regresó a "Elegir opciones": no se sobrescribe
        if (button.textContent === 'Agregando…') button.innerHTML = original;
        button.disabled = false;
        refreshCart();
        return true;
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.textContent = 'Intenta de nuevo';
        setTimeout(function () { button.innerHTML = original; button.disabled = false; }, 1600);
        return false;
      });
  }

  // Mismo evento que el botón de la ficha (Horizon: CartAddEvent = 'cart:update').
  // Actualiza el carrito y abre el cajón; nunca manda a la página /cart.
  function notifyCart(variantId, sections) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: {},
      sourceId: String(variantId),
      data: {
        source: 'product-form-component',
        itemCount: 1,
        variantId: String(variantId),
        sections: sections || {}
      }
    };
    document.dispatchEvent(ev);

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Si el tema ya abre el cajón solo (auto-open), no se abre dos veces
    if (drawer.hasAttribute('auto-open')) return;
    setTimeout(function () {
      if (typeof drawer.open === 'function') drawer.open();
    }, 60);
  }

  function flashAdded(card) {
    var btn = card.querySelector('[data-fnt-pc-btn]');
    if (!btn) return;
    var html = btn.innerHTML;
    btn.classList.add('is-added');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg><span>Agregado</span>';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.innerHTML = html;
    }, 1800);
  }

  var counts = {};
  var vcounts = {};
  var cartTimer = null;

  function refreshCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          counts = {};
          vcounts = {};
          (cart.items || []).forEach(function (it) {
            counts[it.product_id] = (counts[it.product_id] || 0) + it.quantity;
            vcounts[it.variant_id] = (vcounts[it.variant_id] || 0) + it.quantity;
          });
          document.querySelectorAll('[data-fnt-pc]').forEach(paintCount);
        })
        .catch(function () {});
    }, 250);
  }

  function paintCount(card) {
    var n = 0;
    if (card.dataset.variantIds) {
      // Tarjeta de una sola presentación: cuenta solo sus variantes
      card.dataset.variantIds.split(',').forEach(function (id) { n += vcounts[id] || 0; });
    } else {
      n = counts[card.dataset.productId] || 0;
    }
    var tags = card.querySelector('[data-fnt-pc-tags]');
    if (!tags) return;
    var tag = tags.querySelector('.fnt-pc__tag--cart');
    if (n > 0) {
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'fnt-pc__tag fnt-pc__tag--cart';
        tags.appendChild(tag);
      }
      tag.textContent = 'En carrito · ' + n;
    } else if (tag) {
      tag.remove();
    }
  }

  // ---------- Eventos ----------
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-fnt-pc]');

    // Clic fuera: cierra el panel abierto
    if (openCard && card !== openCard && !e.target.closest('.fnt-sheet')) closePanel(openCard);
    if (!card) return;

    if (e.target.closest('[data-fnt-pc-close]')) {
      e.preventDefault();
      closePanel(card);
      return;
    }

    var buy = e.target.closest('[data-fnt-buy]');
    if (buy && card._plan) {
      e.preventDefault();
      card._plan.sub = buy.dataset.fntBuy === 'sub';
      drawPanel(card);
      return;
    }
    if (e.target.closest('[data-fnt-freq]')) return;

    var opt = e.target.closest('[data-fnt-idx]');
    if (opt && card._sel) {
      e.preventDefault();
      card._sel = choose(data(card), card._sel, Number(opt.dataset.fntIdx), opt.dataset.fntVal);
      drawPanel(card);
      return;
    }

    var btn = e.target.closest('[data-fnt-pc-btn]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    if (btn.dataset.mode === 'choose') {
      if (MOBILE.matches) openSheet(card);
      else openPanel(card);
      return;
    }

    // Agregar (una sola opción o panel abierto)
    var id = btn.dataset.variant;
    var plan = null;
    if (card.classList.contains('is-open') && card._plan && card._plan.sub) {
      var pv = findVariant(data(card), card._sel);
      if (pv && pv.sp) plan = card._plan.id;
    }
    addToCart(id, btn, function () {
      if (card.classList.contains('is-open')) closePanel(card);
    }, plan).then(function (ok) { if (ok) flashAdded(card); });
  });

  // Frecuencia elegida en el panel
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-fnt-freq]');
    if (!sel) return;
    var card = sel.closest('[data-fnt-pc]');
    if (card && card._plan) card._plan.id = Number(sel.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openCard) closePanel(openCard);
  });

  // Cambió de tamaño la pantalla con un panel abierto
  MOBILE.addEventListener('change', function () {
    if (openCard) closePanel(openCard);
    if (sheet && sheet.open) closeSheet();
  });

  // Carrito actualizado desde cualquier parte del tema
  document.addEventListener('cart:update', refreshCart);

  // Tarjetas nuevas (recomendaciones, pestañas, editor)
  var paintTimer = null;
  new MutationObserver(function () {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(function () {
      document.querySelectorAll('[data-fnt-pc]:not([data-fnt-seen])').forEach(function (c) {
        c.setAttribute('data-fnt-seen', '');
        paintCount(c);
      });
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCart);
  } else {
    refreshCart();
  }

  window.FntCard = { refreshCart: refreshCart };
})();

/* =============================================================
   F&NT · Ficha: nombres cortos de frecuencia en el selector
   "Entregar cada mes, 10% de descuento" → "Cada mes"
   ============================================================= */
(function () {
  if (window.__fntFreqLabels) return;
  window.__fntFreqLabels = true;

  function shorten(text) {
    var t = String(text || '').split(',')[0].trim();          // quita ", 10% de descuento"
    t = t.replace(/^entregar\s+/i, '');                        // quita "Entregar"
    return t.charAt(0).toUpperCase() + t.slice(1);             // "Cada mes"
  }

  function run() {
    document.querySelectorAll('.fnt-pdp__freq option').forEach(function (opt) {
      if (opt.dataset.fntShort) return;
      opt.dataset.fntShort = '1';
      opt.textContent = shorten(opt.textContent);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

/* =============================================================
   F&NT · Ficha: modalidad elegida (suscripción / compra única)
   Pone una clase en <html> para mostrar el aviso legal solo con suscripción.
   ============================================================= */
(function () {
  if (window.__fntPlanState) return;
  window.__fntPlanState = true;

  function sync() {
    var box = document.querySelector('[data-fnt-plans]');
    var root = document.documentElement;
    if (!box) {
      root.classList.remove('fnt-plan-sub', 'fnt-plan-once');
      return;
    }
    var checked = box.querySelector('input[type="radio"]:checked');
    var sub = !checked || checked.value === 'sub';
    root.classList.toggle('fnt-plan-sub', sub);
    root.classList.toggle('fnt-plan-once', !sub);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-fnt-plans]')) sync();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
})();
